(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp_banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionSelector = '[data-sp-banner-section]';
    var defaultTargetSelector = 'featured-product-information';

    function queryElement(selector, fallbackSelector) {
      try {
        return document.querySelector(selector) || document.querySelector(fallbackSelector);
      } catch (error) {
        return document.querySelector(fallbackSelector);
      }
    }

    function querySectionElement(selector, fallbackSelector) {
      var element = queryElement(selector, fallbackSelector);

      if (!element) return null;

      return element.closest('.shopify-section') || element;
    }

    function initBannerCta(section) {
      if (section.dataset.ctaInitialized === 'true') return;

      var link = section.querySelector('[data-sp-banner-cta-link]');
      if (!link) return;

      var target = querySectionElement(
        section.dataset.targetSelector || defaultTargetSelector,
        defaultTargetSelector
      );

      if (!target) {
        var initAttempts = parseInt(section.dataset.ctaInitAttempts || '0', 10);

        if (initAttempts >= 20) return;

        section.dataset.ctaInitAttempts = String(initAttempts + 1);

        window.setTimeout(function () {
          initBannerCta(section);
        }, 250);
        return;
      }

      var abortController = new AbortController();
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      section.dataset.ctaInitialized = 'true';
      delete section.dataset.ctaInitAttempts;
      section.spBannerCtaAbortController = abortController;

      link.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          target.scrollIntoView({
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
            block: 'start',
          });

          if (target.id) {
            history.replaceState(null, '', '#' + target.id);
          }
        },
        { signal: abortController.signal }
      );
    }

    function initBannerCtas(root) {
      var scope = root || document;
      var sections = [];

      if (scope.matches && scope.matches(sectionSelector)) {
        sections.push(scope);
      }

      scope.querySelectorAll(sectionSelector).forEach(function (section) {
        sections.push(section);
      });

      sections.forEach(initBannerCta);
    }

    function unloadBannerCtas(root) {
      var scope = root || document;
      var sections = [];

      if (scope.matches && scope.matches(sectionSelector)) {
        sections.push(scope);
      }

      scope.querySelectorAll(sectionSelector).forEach(function (section) {
        sections.push(section);
      });

      sections.forEach(function (section) {
        if (section.spBannerCtaAbortController) {
          section.spBannerCtaAbortController.abort();
        }

        delete section.dataset.ctaInitialized;
        delete section.spBannerCtaAbortController;
      });
    }

    if (!window.SwipePadsBannerCta) {
      window.SwipePadsBannerCta = {
        init: initBannerCtas,
        unload: unloadBannerCtas,
      };

      document.addEventListener('shopify:section:load', function (event) {
        window.SwipePadsBannerCta.init(event.target);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        window.SwipePadsBannerCta.unload(event.target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          window.SwipePadsBannerCta.init(document);
        },
        { once: true }
      );
    } else {
      window.SwipePadsBannerCta.init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp_floating_cta_bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var barSelector = '[data-sp-floating-cta-bar]';
    var defaultHeroSelector = '.sp_hero_section';
    var defaultTargetSelector = 'featured-product-information';
    var defaultBannerSelector = '.sp_banner';

    function queryElement(selector, fallbackSelector) {
      try {
        return document.querySelector(selector) || document.querySelector(fallbackSelector);
      } catch (error) {
        return document.querySelector(fallbackSelector);
      }
    }

    function querySectionElement(selector, fallbackSelector) {
      var element = queryElement(selector, fallbackSelector);

      if (!element) return null;

      return element.closest('.shopify-section') || element;
    }

    function setVisible(bar, link, nextVisible) {
      var currentVisible = bar.dataset.visible === 'true';

      if (currentVisible === nextVisible) return;

      bar.dataset.visible = String(nextVisible);
      bar.setAttribute('aria-hidden', String(!nextVisible));

      if (!link) return;

      if (nextVisible) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }
    }

    function getScrollContainer() {
      var pageWrapper = document.querySelector('.page-wrapper');

      if (pageWrapper) {
        var computed = window.getComputedStyle(pageWrapper);
        var overflowY = computed.overflowY;

        if (overflowY === 'auto' || overflowY === 'scroll') {
          return pageWrapper;
        }
      }

      return window;
    }

    function initBar(bar) {
      if (bar.dataset.initialized === 'true') return;

      var hero = querySectionElement(bar.dataset.heroSelector || defaultHeroSelector, defaultHeroSelector);
      var target = querySectionElement(bar.dataset.targetSelector || defaultTargetSelector, defaultTargetSelector);
      var banner = querySectionElement(bar.dataset.bannerSelector || defaultBannerSelector, defaultBannerSelector);
      var link = bar.querySelector('[data-sp-floating-cta-link]');

      if (!hero || !target) {
        var initAttempts = parseInt(bar.dataset.initAttempts || '0', 10);

        if (initAttempts >= 20) return;

        bar.dataset.initAttempts = String(initAttempts + 1);

        window.setTimeout(function () {
          initBar(bar);
        }, 250);
        return;
      }

      var abortController = new AbortController();
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var heroHasPassed = false;
      var targetIsInViewport = false;
      var bannerIsInViewport = false;
      var bannerHasPassed = false;

      bar.dataset.initialized = 'true';
      delete bar.dataset.initAttempts;
      bar.spFloatingCtaAbortController = abortController;

      function updateVisibility() {
        var bannerIsVisible = bannerIsInViewport || bannerHasPassed;
        setVisible(bar, link, heroHasPassed && !targetIsInViewport && !bannerIsVisible);
      }

      var heroObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;

          heroHasPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          updateVisibility();
        },
        { threshold: [0, 0.01, 1], rootMargin: '0px' }
      );

      var targetObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;

          targetIsInViewport = entry.isIntersecting;
          updateVisibility();
        },
        { threshold: [0, 0.01] }
      );

      var bannerObserver = null;

      if (banner) {
        bannerObserver = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (!entry) return;

            bannerIsInViewport = entry.isIntersecting;
            bannerHasPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            updateVisibility();
          },
          { threshold: [0, 0.01, 1], rootMargin: '0px' }
        );
      }

      heroObserver.observe(hero);
      targetObserver.observe(target);

      if (bannerObserver) {
        bannerObserver.observe(banner);
      }

      var scrollContainer = getScrollContainer();
      var resizeHandler = function () {
        heroObserver.disconnect();
        targetObserver.disconnect();
        heroObserver.observe(hero);
        targetObserver.observe(target);

        if (bannerObserver) {
          bannerObserver.disconnect();
          bannerObserver.observe(banner);
        }
      };

      window.addEventListener('resize', resizeHandler, { signal: abortController.signal });
      window.addEventListener('load', resizeHandler, { once: true, signal: abortController.signal });

      if (scrollContainer && scrollContainer !== window) {
        scrollContainer.addEventListener('scroll', resizeHandler, { passive: true, signal: abortController.signal });
      }

      if (link) {
        link.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            target.scrollIntoView({
              behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
              block: 'start',
            });

            if (target.id) {
              history.replaceState(null, '', '#' + target.id);
            }
          },
          { signal: abortController.signal }
        );
      }

      bar.spFloatingCtaHeroObserver = heroObserver;
      bar.spFloatingCtaTargetObserver = targetObserver;
      bar.spFloatingCtaBannerObserver = bannerObserver;
    }

    function initBars(root) {
      var scope = root || document;
      var bars = [];

      if (scope.matches && scope.matches(barSelector)) {
        bars.push(scope);
      }

      scope.querySelectorAll(barSelector).forEach(function (bar) {
        bars.push(bar);
      });

      bars.forEach(initBar);
    }

    function unloadBars(root) {
      var scope = root || document;
      var bars = [];

      if (scope.matches && scope.matches(barSelector)) {
        bars.push(scope);
      }

      scope.querySelectorAll(barSelector).forEach(function (bar) {
        bars.push(bar);
      });

      bars.forEach(function (bar) {
        if (bar.spFloatingCtaAbortController) {
          bar.spFloatingCtaAbortController.abort();
        }

        if (bar.spFloatingCtaHeroObserver) {
          bar.spFloatingCtaHeroObserver.disconnect();
        }

        if (bar.spFloatingCtaTargetObserver) {
          bar.spFloatingCtaTargetObserver.disconnect();
        }

        if (bar.spFloatingCtaBannerObserver) {
          bar.spFloatingCtaBannerObserver.disconnect();
        }

        delete bar.dataset.initialized;
        delete bar.spFloatingCtaAbortController;
        delete bar.spFloatingCtaHeroObserver;
        delete bar.spFloatingCtaTargetObserver;
        delete bar.spFloatingCtaBannerObserver;
      });
    }

    if (!window.SwipePadsFloatingCtaBar) {
      window.SwipePadsFloatingCtaBar = {
        init: initBars,
        unload: unloadBars,
      };

      document.addEventListener('shopify:section:load', function (event) {
        window.SwipePadsFloatingCtaBar.init(event.target);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        window.SwipePadsFloatingCtaBar.unload(event.target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          window.SwipePadsFloatingCtaBar.init(document);
        },
        { once: true }
      );
    } else {
      window.SwipePadsFloatingCtaBar.init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp_hero_section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionSelector = '[data-sp-hero-section]';
    var defaultTargetSelector = 'featured-product-information';

    function queryElement(selector, fallbackSelector) {
      try {
        return document.querySelector(selector) || document.querySelector(fallbackSelector);
      } catch (error) {
        return document.querySelector(fallbackSelector);
      }
    }

    function querySectionElement(selector, fallbackSelector) {
      var element = queryElement(selector, fallbackSelector);

      if (!element) return null;

      return element.closest('.shopify-section') || element;
    }

    function initHeroCta(section) {
      if (section.dataset.ctaInitialized === 'true') return;

      var link = section.querySelector('[data-sp-hero-cta-link]');
      if (!link) return;

      var target = querySectionElement(
        section.dataset.targetSelector || defaultTargetSelector,
        defaultTargetSelector
      );

      if (!target) {
        var initAttempts = parseInt(section.dataset.ctaInitAttempts || '0', 10);

        if (initAttempts >= 20) return;

        section.dataset.ctaInitAttempts = String(initAttempts + 1);

        window.setTimeout(function () {
          initHeroCta(section);
        }, 250);
        return;
      }

      var abortController = new AbortController();
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      section.dataset.ctaInitialized = 'true';
      delete section.dataset.ctaInitAttempts;
      section.spHeroCtaAbortController = abortController;

      link.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          target.scrollIntoView({
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
            block: 'start',
          });

          if (target.id) {
            history.replaceState(null, '', '#' + target.id);
          }
        },
        { signal: abortController.signal }
      );
    }

    function initHeroCtas(root) {
      var scope = root || document;
      var sections = [];

      if (scope.matches && scope.matches(sectionSelector)) {
        sections.push(scope);
      }

      scope.querySelectorAll(sectionSelector).forEach(function (section) {
        sections.push(section);
      });

      sections.forEach(initHeroCta);
    }

    function unloadHeroCtas(root) {
      var scope = root || document;
      var sections = [];

      if (scope.matches && scope.matches(sectionSelector)) {
        sections.push(scope);
      }

      scope.querySelectorAll(sectionSelector).forEach(function (section) {
        sections.push(section);
      });

      sections.forEach(function (section) {
        if (section.spHeroCtaAbortController) {
          section.spHeroCtaAbortController.abort();
        }

        delete section.dataset.ctaInitialized;
        delete section.spHeroCtaAbortController;
      });
    }

    if (!window.SwipePadsHeroCta) {
      window.SwipePadsHeroCta = {
        init: initHeroCtas,
        unload: unloadHeroCtas,
      };

      document.addEventListener('shopify:section:load', function (event) {
        window.SwipePadsHeroCta.init(event.target);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        window.SwipePadsHeroCta.unload(event.target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          window.SwipePadsHeroCta.init(document);
        },
        { once: true }
      );
    } else {
      window.SwipePadsHeroCta.init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
